import { CallApi, handleJSONResponse } from './common';
import { EarningsResponse } from '@services/earnings/types/earnings-response';
import { EarningsOwnerType } from '@services/earnings/types/earnings-owner-type';
import { exportType } from '@services/earnings/types/earnings-export-type';
import Dinero, { DineroObject } from 'dinero.js';
// import moment from 'moment';

const callAPI = CallApi('earnings');

export const total = async (
  ownerType: EarningsOwnerType,
  id: string
): Promise<Dinero.Dinero> => {
  const response = await callAPI(`/${ownerType}/${id}/total`, 'GET');

  const amount = await handleJSONResponse(response);

  return Dinero(amount as Dinero.DineroObject);
};

export const list = async (
  ownerType: EarningsOwnerType,
  id: string,
  dsp: string = '',
  reportDate: string = '',
  eligibleDate: number = 0
): Promise<EarningsResponse[]> => {
  const response = await callAPI(
    `/${ownerType}/${id}?dsp=${dsp}&reportDate=${reportDate}&eligibleDate=${eligibleDate}`,
    'GET'
  );

  return handleEarningsResponse(response);
};

const handleEarningsResponse = async (
  response: Response
): Promise<EarningsResponse[]> => {
  const data: EarningsResponse[] = await handleJSONResponse(response);

  return data.map((entry) => ({
    ...entry,
    total: Dinero(entry.total as unknown as DineroObject),
    pending: Dinero(entry.pending as unknown as DineroObject),
    available: Dinero(entry.available as unknown as DineroObject),
    eligibleDate: new Date(entry.eligibleDate),
    paid: entry.paid ? new Date(entry.paid) : undefined,

    entries: entry.entries.map((e) => ({
      ...e,
      value: Dinero(e.value as unknown as DineroObject),
      original: Dinero(e.original as unknown as DineroObject),

      paid: e.paid ? new Date(e.paid) : undefined,
      eligibleDate: e.eligibleDate ? new Date(e.eligibleDate) : undefined,
    })),
  }));
};

export const generateExportUrl = async (
  ownerType: EarningsOwnerType,
  id: string,
  requestType: 'monthly' | 'yearly' | 'all',
  requestedPeriod: string,
  exportType: exportType
) => {
  const response = await callAPI(
    `/export/${ownerType}/${id}?exportType=${exportType}&requestType=${requestType}&requestedPeriod=${requestedPeriod}`,
    'GET'
  );

  const body = await handleJSONResponse(response);

  return body;
};

export const getExportUrl = async (ownerId: string, requestId: string) => {
  const response = await callAPI(
    `/validate-export/${ownerId}/${requestId}`,
    'GET'
  );

  const body = await handleJSONResponse(response);

  return body;
};
